<template>
  <b-container fluid>
    <b-row>
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="searchText"
            placeholder="Enter Search Text"
            size="sm"
          />
          <b-input-group-append>
            <b-form-select
              size="sm"
              v-model="searchType"
              :options="options"
            ></b-form-select>
            <b-button variant="info" @click="search" size="sm">Search</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="3"></b-col>
      <b-col md="4">
        <b-row class="my-2">
          <b-col md="10">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Search"
                size="sm"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''" size="sm"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="2">
            <p class="float-right">
              <small> Rows: {{ totalRows }} </small>
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col md="12">
            <b-table
              id="tblSummary"
              show-empty
              selectable
              select-mode="multi"
              head-variant="dark"
              empty-text="No Records available."
              stacked="md"
              bordered
              striped
              :items="callSummary"
              :fields="fields"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @filtered="onFiltered"
              small
            >
              <template v-slot:cell(action)="row">
                <b-button
                  size="sm"
                  @click.stop="redirect(row.item)"
                  class="mr-1 pt-0 pb-0"
                  variant="success"
                  v-b-tooltip.hover
                  title="View Details"
                  >View</b-button
                >
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import apis from "@/apis";

export default {
  data() {
    return {
      summary: [
        { _id: "Pending", count: 5, sum: 0 },
        { _id: "Positive", count: 1, sum: 0 },
      ],
      totalCount: 0,
      newCount: 0,
      positiveCount: 0,
      callbacks: 0,
      callSummary: [],
      fields: [
        { key: "positiveFlag", label: "Positive?", sortable: true },
        { key: "lastCallResponse", label: "Last Status", sortable: true },
        { key: "count", label: "Count", sortable: true },
        { key: "action" },
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      totalRows: 0,
      searchType: "mobile",
      searchText: "",
      options: [
        { value: "mobile", text: "Mobile No" },
        { value: "name", text: "Customer Name" },
      ],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    redirect(item) {
      this.$session.remove("callList");
      this.$session.remove("filter");
      this.$router.replace({
        name: "CallList",
        params: {
          positiveResponse: item.positiveFlag,
          lastResponse: item.lastCallResponse,
        },
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      //this.currentPage = 1;
    },
    search() {
      let payLoad = {
        processName: this.$store.getters.currentProcess,
        searchType: this.searchType,
        searchText: this.searchText,
      };
      //alert(JSON.stringify(payLoad));
      let promise = apis.searchCase(payLoad);
      promise
        .then((response) => {
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              this.$session.set("callList", response.data.data);
              this.$session.remove("filter");
              this.$router.replace({
                name: "CallList",
                params: {
                  positiveResponse: "all",
                  lastResponse: "New",
                },
              });
            } else {
              alert("No Records Found.");
            }
          }
        })
        .catch((err) => {
          console.error(err);
          this.isBusy = false;
        });
    },
  },
  mounted() {
    var data={userid:this.$store.getters.loggedUser.userName,processname:this.$store.getters.currentProcess};
    let Promise = apis.dashboard(data
    );

    Promise.then((response) => {
      if (response.status == 200) {
        this.$store.dispatch("setCollection", {
          collection: response.body.collectionName,
          priority: response.body.priorityNum,
          form: response.body.form,
        });
        this.callSummary = response.body.summary;
        this.totalRows = response.body.summary.length;
        // var i;
        // for (i = 0; i < response.body.summary.length; i++) {
        //   switch (response.body.summary[i]._id) {
        //     case "Pending":
        //       this.newCount = response.body.summary[i].count;
        //       this.totalCount += this.newCount;
        //       break;
        //     case "Positive":
        //       this.positiveCount = response.body.summary[i].count;
        //       this.totalCount += this.positiveCount;
        //       break;
        //   }
        // }
      }
    });
  },
};
</script>

<style scoped>
body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: Montserrat, Helvetica Neue, Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
</style>